import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionKey, getCollectionsKey, getOrganizeSpacesInCollectionKey, getSpacesKey, } from '../../utils/keys';
export const useOrganizeSpacesInCollection = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.collections.organizeSpaces(input), {
        onSettled: (data, error, { collectionId }) => {
            const spacesKey = getSpacesKey({ collectionId });
            queryClient.invalidateQueries(spacesKey);
            const collectionKey = getCollectionKey({ id: collectionId });
            queryClient.invalidateQueries(collectionKey);
            const collectionsKey = getCollectionsKey();
            queryClient.invalidateQueries(collectionsKey);
        },
        mutationKey: getOrganizeSpacesInCollectionKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useOrganizeSpacesInCollection.js.map